
import { Box } from "@mui/material";
import { useLanguageContext } from "../../contexts/LanguageContext";
import { useUserContext } from "../../contexts/UserContext";
import { INavigationLink } from "../../interfaces/INavigation";
import { useNavigationContext } from "../../contexts/NavigationContext";
import { IMuiIcon } from "../../interfaces/IMaterial";


interface INavigationLinkProps {
    link: INavigationLink;
    expandedLinks: INavigationLink[];
    handleChangeExpandedLinks: (navigationLink: INavigationLink) => void;
    handleCloseNavigation: () => void;
}


const Link: React.FC<INavigationLinkProps> = ({
    link,
    expandedLinks,
    handleChangeExpandedLinks,
    handleCloseNavigation
}) => {
    const { translate } = useLanguageContext();
    const { userPermissions } = useUserContext();
    const { selectedNavigationLink, setSelectedNavigationLink } = useNavigationContext();

    const Icon = link.Icon as IMuiIcon;
    
    if (link.alias.filter(alias => userPermissions.includes(alias)).length === 0) {
        return null;
    }

    
    if (link.items != null && link.items.length > 0) {
        const isExpanded = expandedLinks.filter((x: INavigationLink) => x.alias === link.alias).length > 0;
        const expandedClass = isExpanded ? 'expanded' : '';

        return (
            <>
                <Box 
                    key={`link-${link.alias}`}
                    component='div' 
                    className={`box-link list-indicator ${expandedClass}`} 
                    onClick={() => handleChangeExpandedLinks(link)}
                >
                    <Icon className='image-icon' />
                    <span> { translate(link.name) } </span>
                </Box>

                {
                    (
                        isExpanded &&
                        (
                            <Box key={`navigationlink-${link.alias}-list`} component='div' className='box-list-container'>
                                {
                                    link.items.map((item: INavigationLink) => {
                                        return (
                                            <Link
                                                link={item}
                                                expandedLinks={expandedLinks}
                                                handleChangeExpandedLinks={handleChangeExpandedLinks}
                                                handleCloseNavigation={() => handleCloseNavigation()}
                                                key={`navigationlink-${item.alias}`}
                                            />
                                        );
                                    })
                                }
                            </Box>
                        )
                    )
                }
            </>
        );
    }

    const selectedClass = selectedNavigationLink != null && selectedNavigationLink.alias === link.alias ? 'selected' : '';
    
    return (
        <Box
            key={`navigationlink-${link.alias}`}
            component='div' 
            className={`box-link ${selectedClass}`} 
            onClick={() => {
                setSelectedNavigationLink(link);
                handleCloseNavigation();
            }}
        >
            <Icon className='image-icon' />
            <span> { translate(link.name) } </span>
        </Box>
    );
}


export default Link;